export function isScreenshotPathname(pathname: string): boolean {
  return pathname.includes("/screenshot/");
}

export function isScreenshotPageLocation({
  pathname,
  search = "",
}: {
  pathname: string;
  search?: string;
}): boolean {
  return (
    new URLSearchParams(search).get("screenshot") === "true" ||
    isScreenshotPathname(pathname)
  );
}
